import React from 'react'

const styles = {
  socialIcon: {
    textIndent:'100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    paddingLeft: '0!important',
    paddingRight: '0',
    marginLeft: '10px',
    backgroundSize: '20px 20px',
    backgroundRepeat: 'no-repeat'
  },
  socialIconLink: {
    display: 'block',
    width: '15px',
    height: '20px'
  }
}

const FooterIcon = props => {
  let title = props.title

  return (
    <li style={{ ...props.icon, ...styles.socialIcon }}>
      <a style={ styles.socialIconLink } href={ props.link } rel="noopener noreferrer" target="_blank" title={ title }>{ title }</a>
    </li>
  )
}

export default FooterIcon
